.video-carousel {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    padding: 20px 0;
    scrollbar-width: none;
    -ms-overflow-style: none;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 40px;
}

.video-carousel::-webkit-scrollbar {
    display: none;
}

.video-carousel__item {
    flex: 0 0 auto;
    width: calc(100% / var(--items-visible, 5) - (12px * (var(--items-visible, 5) - 1) / var(--items-visible, 5)));
    aspect-ratio: 9/16;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    background-color: #000;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    scroll-snap-align: center;
    filter: brightness(0.9);
    transform: scale(0.9);
}

.video-carousel__item--focused {
    filter: brightness(1);
    transform: scale(1);
    z-index: 2;
}

.video-carousel__item:hover {
    filter: brightness(1);
}

.video-carousel__thumbnail {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
}

.video-carousel__thumbnail video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-carousel__overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 8px;
    background-color: rgb(0 0 0 / 0.4);
    color: #FFF;
    z-index: 1;
}

.video-carousel__title {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}

.video-carousel__play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    background-color: rgb(0 0 0 / 0.4);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
}

.video-carousel__item:hover .video-carousel__play-btn {
    opacity: 1;
}

.video-carousel__play-btn svg {
    width: 24px;
    height: 24px;
    color: #FFF;
}

.video-carousel-container {
    width: 100%;
    position: relative;
}

.video-carousel__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.1);
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s ease;
    padding: 0;
    outline: none;
}

.video-carousel__nav:hover {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transform: translateY(-50%) scale(1.1);
}

.video-carousel__nav svg {
    width: 20px;
    height: 20px;
}

.video-carousel__nav--prev {
    left: 0;
}

.video-carousel__nav--next {
    right: 0;
}

.video-carousel__preview-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}

@media (max-width: 768px) {
    .video-carousel__item {
        width: calc(100% - 60px);
    }

    .video-carousel__title {
        font-size: 12px;
    }
}